import React from 'react';

/**
 * Responsive grid of detail panels shown inside an expanded row. `columns` maps
 * to the `--crud-detail-cols` custom property that drives the grid template.
 */
export const DetailGrid = ({ columns = 3, className = '', children }) => (
  <div
    className={`crud-detail-grid p-3 border rounded ${className}`.trim()}
    style={{ '--crud-detail-cols': columns }}
  >
    {children}
  </div>
);

/**
 * A single `.detail-panel` card with an optional heading. Pass `actions` to add
 * the `.actions-panel` modifier (used for stacked edit/delete buttons).
 */
export const DetailPanel = ({ title, actions = false, className = '', children }) => (
  <div className={`detail-panel${actions ? ' actions-panel' : ''} ${className}`.trim()}>
    {title ? <h6 className="mb-2">{title}</h6> : null}
    {children}
  </div>
);

/**
 * A label/value line inside a detail panel (`.schedule-summary-row`).
 */
export const SummaryRow = ({ label, value }) => (
  <div className="schedule-summary-row">
    <strong>{label}</strong>
    <span>{value}</span>
  </div>
);

export default DetailGrid;
